/**
 * PLayer Panel component
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';
/* eslint no-path-concat: 0 */
/* eslint no-use-before-define:0*/

var Component   = require('stb-component'),
    keys        = require('stb-keys'),
    LayoutList  = require('mag-component-layout-list');


function Player ( config ) {
    var $buttonsWrapper;

    config = config || {};

    config.className = 'playerPanel ' + (config.className || '');

    config.$body = document.createElement('div');
    config.$body.className = 'body';


    Component.call(this, config);

    this.$node.appendChild(this.$body);


    this.$body.appendChild(this.$leftText = document.createElement('div'));
    this.$leftText.className = 'leftText';

    this.$body.appendChild($buttonsWrapper = document.createElement('div'));
    $buttonsWrapper.className = 'buttonsWrapper';

    this.buttons = new LayoutList({
        focusIndex: 2,
        cycle: true,
        propagate: true,
        parent: this,
        type: LayoutList.prototype.TYPE_HORIZONTAL,
        className: 'playerButtons',
        data: [],
        events: {
            keydown: function ( event ) {
                if ( event.code !== keys.pageDown && event.code !== keys.pageUp ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                }
            }
        }
    });

    $buttonsWrapper.appendChild(this.buttons.$node);

    this.$body.appendChild(this.$rightText = document.createElement('div'));
    this.$rightText.className = 'rightText';

    // this.buttons.move = function ( dir ) {
    //     customMove.call(this, dir);
    // };

    this.init(config);
}


Player.prototype = Object.create(Component.prototype);
Player.prototype.constructor = Player;

Player.prototype.init = function ( config ) {
    var buttons = [
        {
            // channel - btn
            items: [{value: '<', className: 'button theme-icon theme-icon-rotate'}],
            click: function () { if ( config.onRotate ) { config.onRotate({direction: keys.left}); } }
        },
        {
            // prev content btn
            items: [{value: '', className: 'button theme-icon theme-icon-previous'}],
            click: function () { if ( config.onPrevNext ) { config.onPrevNext({direction: keys.left}); } }
        },
        {
            // play/pause btn
            items: [{value: '', className: 'button theme-icon theme-icon-play'}],
            click: function () { if ( config.onPlay ) { config.onPlay(); } }
        },
        {
            // next content btn
            items: [{value: '', className: 'button theme-icon theme-icon-next'}],
            click: function () { if ( config.onPrevNext ) { config.onPrevNext({direction: keys.right}); } }
        },
        {
            // channel + btn
            items: [{value: '>', className: 'button theme-icon theme-icon-rotate-back'}],
            click: function () { if ( config.onRotate ) { config.onRotate({direction: keys.right}); } }
        }
    ];


    this.buttons.init({
        data: buttons,
        size: buttons.length,
        focusIndex: 2
    });


    if ( config.play !== false ) {
        this.$playPauseBtn = document.getElementsByClassName('theme-icon-play')[0];
    }

    /*this.buttons.addListener('focus:item', function ( event ) {
        var next = event.$curr,
            prev = event.$prev;


       *//* if ( next.index > prev.index && next.data.disabled ) {
            self.buttons.emit('keydown', {code:keys.right});
        } else if ( next.index < prev.index && next.data.disabled ) {
            self.buttons.emit('keydown', {code:keys.left});
        }*//*

        *//*if ( event.$curr.data.disabled ) {
            self.buttons.focusItem(event.$prev);
            debug.log('try to focus disabled', 'yellow');
        }*//*
    });*/

};

/*eslint no-invalid-this:0*/

Player.prototype.focus = function () {
    this.buttons.focus();
};


// 0 rotate left - btn
// 1 prev content btn
// 2 pause btn
// 3 next content btn
// 4 rotate right btn

Player.prototype.initButtons = function ( config ) {
    config = config || {};

    this.buttons.enabledCount = 0;


    if ( config.prev ) {
        this.buttons.$body.children[1].classList.remove('disabled');
        this.buttons.$body.children[1].data.disabled = false;
        this.buttons.enabledCount++;
    } else {
        this.buttons.$body.children[1].classList.add('disabled');
        this.buttons.$body.children[1].data.disabled = true;
    }


    if ( config.play ) {
        this.buttons.$body.children[3].classList.remove('disabled');
        this.buttons.$body.children[3].data.disabled = false;
        this.buttons.enabledCount++;
    } else {
        this.buttons.$body.children[3].classList.add('disabled');
        this.buttons.$body.children[3].data.disabled = true;
    }


    if ( config.next ) {
        this.buttons.$body.children[3].classList.remove('disabled');
        this.buttons.$body.children[3].data.disabled = false;
        this.buttons.enabledCount++;
    } else {
        this.buttons.$body.children[3].classList.add('disabled');
        this.buttons.$body.children[3].data.disabled = true;
    }
};

module.exports = Player;
